import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { IEpgItem } from "../../interfaces/IEpgItem";
import DateHelper from "../../helpers/dateHelper";
import UtilsHelper from "../../helpers/utilsHelper.ts";
import { useContext } from "react";
import { AppMainStateContext } from "../../contexts/AppMainStateContext.tsx";
import { useAppDispatch, useAppSelector } from "../../stores/store.ts";
import { getEpgDetailsAsync } from "../epg/EpgDetailsModal/epgDetailsSlice.ts";
import { modalsStateActions } from "../popups/modalsStateSlice.ts";

interface props {
    index: number;
    epg: IEpgItem | null;
    channelName: string;
}

export default function PlayerEpgItem({
    index,
    epg,
    channelName,
}: props) {
    const { openModal } = useContext(AppMainStateContext);
    const dispatch = useAppDispatch();
    const lastOperationType = useAppSelector(store => store.playerUI.lastOperationType);
    const handleClickEpgInfo = (id: number) => {
        dispatch(getEpgDetailsAsync({ id, channelName }));
        dispatch(modalsStateActions.setIsEpgDetailsOpen(true))
        openModal();
    }
    return (
        <div
            data-epg-id={index}
            data-epg-start={epg && epg.start_timestamp ? epg.start_timestamp : 0}
            data-epg-end={epg && epg.stop_timestamp ? epg.stop_timestamp : 0}
            className={`${lastOperationType === "CHANGE_EPG_RIGHT" && "playerChannel-scrollRightAnimation"} ${lastOperationType === "CHANGE_EPG_LEFT" && "playerChannel-scrollLeftAnimation"} transition duration-150 snap-start flex shrink-0 w-full flex-col`}
        >
            <div className={`flex justify-between text-base md:text-xl`}>
                <div className={"flex flex-col space-y-1 overflow-hidden"}>
                    <div className={"flex flex-col"}>
                        <p className={"truncate"}>
                            {epg && epg.name ? epg.name : "Brak danych"}
                        </p>
                        {epg ?
                            <p className={"text-sm text-neutral-400"}>{`${DateHelper.GetHourAndMinuteFromUnixTimespanDate(epg.start_timestamp)} - ${DateHelper.GetHourAndMinuteFromUnixTimespanDate(epg.stop_timestamp)}`} </p>
                            :
                            <span>-</span>
                        }
                    </div>
                </div>
                {epg &&
                    <div className="flex items-start">
                        <button
                            className={"pl-2"}
                            type={"button"}
                            onClick={() =>
                                handleClickEpgInfo(epg?.id)
                            }
                        >
                            <InformationCircleIcon className="w-8 h-8" />
                        </button>
                    </div>
                }
            </div>
            <div className="flex-start flex h-1 w-full overflow-hidden bg-neutral-600 font-sans text-xs font-medium rounded-full mt-1">
                {epg && (
                    <div
                        className={`flex h-full items-center justify-center overflow-hidden break-all bg-[#008DD2] bg-gradient-to-b from-sky-500 to-sky-900 text-white rounded-full`}
                        style={{ width: UtilsHelper.calcProgressBar(epg) }}
                    />
                )}
            </div>
        </div>
    );
}
